import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'use-intl';

import { SignupCompleteContent } from '@/screens/signup/complete/SignupCompleteContent';

export const Route = createFileRoute('/_app/signup/complete/')({
  component: SignupCompleteRoute,
});

function LoadingSpinner() {
  const t = useTranslations('signup.complete');
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">{t('verifyingToken')}</p>
      </div>
    </div>
  );
}

function SignupCompleteRoute() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <SignupCompleteContent />
    </Suspense>
  );
}
